module.exports = __webpack_public_path__ + "img/new-guide-01-1.35c25e5a.png";